import { SelectInputV2, SelectInputV2Props } from '@frontend/basic-forms';
import { EquipmentStateName } from '@frontend/equipment/types';
import React from 'react';

import useEquipmentStateSelect from './equipment-state-select.controller';

const ID = 'equipment-state-select';
export interface EquipmentStateSelectProps extends Omit<SelectInputV2Props<EquipmentStateName>, 'options'> {
    subset?: string[] | (() => Promise<string[]>);
}

/**
 * @deprecated
 * Used by terminal s4m
 */
export const EquipmentStateSelect = (props: EquipmentStateSelectProps) => {
    const viewProps = useEquipmentStateSelect(props);
    return (
        <SelectInputV2<EquipmentStateName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Equipment state'}
            options={viewProps.options}
        />
    );
};
